// #Cursor JavaScript Place Here#
document.addEventListener("DOMContentLoaded", function () {
    const cursor = document.getElementById("cursor");

    cursor.style.margin = "-9px"; // Apply margin when page loads

    document.addEventListener("mousemove", (e) => {
        cursor.style.transform = `translate(${e.clientX}px, ${e.clientY}px)`;
        cursor.style.opacity = "1";
    });

    document.querySelectorAll('.button-hover, a, h1, img, button').forEach(el => {
        el.addEventListener("mouseenter", () => {
            cursor.style.width = "50px";
            cursor.style.height = "50px";
            cursor.style.margin = "-20px"; // Apply margin only when enlarged

        });
        el.addEventListener("mouseleave", () => {
            cursor.style.width = "20px";
            cursor.style.height = "20px";
            cursor.style.margin = "-9px"; // Reset margin when back to normal
        });
    });

    // Optional: Hide cursor near edges
    document.addEventListener("mousemove", function (e) {
        const edgeBuffer = 10;
        if (
            e.clientX <= edgeBuffer ||
            e.clientY <= edgeBuffer ||
            e.clientX >= window.innerWidth - edgeBuffer ||
            e.clientY >= window.innerHeight - edgeBuffer
        ) {
            cursor.style.opacity = "0";
        } else {
            cursor.style.opacity = "1";
        }
    });
});
